import { render } from "./EmptyView.vue?vue&type=template&id=7b15b376&scoped=true"
import script from "./EmptyView.vue?vue&type=script&lang=js"
export * from "./EmptyView.vue?vue&type=script&lang=js"

import "./EmptyView.vue?vue&type=style&index=0&id=7b15b376&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b15b376"]])

export default __exports__